import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Message } from 'primeng/api';
import { loadPaymentSettingsCurrent, updatePaymentSettings } from 'src/app/store/payment-settings/payment-settings.actions';
import { selectPaymentSettingsCurrent, selectPaymentSettingsCurrentLoading } from 'src/app/store/payment-settings/payment-settings.selectors';

@Component({
  selector: 'app-dados-repasse',
  templateUrl: './dados-repasse.component.html',
  styleUrls: ['./dados-repasse.component.scss'],
})
export class DadosRepasseComponent implements OnInit {
  messages: Message[] = [
    {
      severity: 'warn',
      summary: '',
      detail:
        'Preencha essas informações pela primeira vez e salve as suas preferências. ',
    },
  ];

  repasseForm = this.fb.group({
    calculatedPayout: false,
  });

  isLoading$ = this.store.select(selectPaymentSettingsCurrentLoading)

  constructor(private fb: FormBuilder, private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(loadPaymentSettingsCurrent({ id: Number(localStorage.getItem('clientId')) }));
    this.store.select(selectPaymentSettingsCurrent).subscribe({
      next: (res) => {
        if (res) {
          this.popularFormulario(res);
        }
      },
    });
  }

  popularFormulario(res: any) {
    console.log('popularFormulario');
    console.log(res);
    this.repasseForm.patchValue(res);
  }

  saveChange() {
    const req = this.repasseForm.value;
    this.store.dispatch(
      updatePaymentSettings({ id: Number(localStorage.getItem('clientId')), paymentSettings: req as any })
    );
  }

}
